import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=629b4e72&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=629b4e72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b4e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629b4e72')) {
      api.createRecord('629b4e72', component.options)
    } else {
      api.reload('629b4e72', component.options)
    }
    module.hot.accept("./MaintenancePage.vue?vue&type=template&id=629b4e72&scoped=true", function () {
      api.rerender('629b4e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/MaintenancePage.vue"
export default component.exports